import { KText } from '@/ui-library/components/text';
import { Flex } from '@chakra-ui/react';
import { components } from 'react-select';

export const SelectWithRightCompOption = (props) => {
  const { data, selectProps = {} } = props;
  const { extraProps = {} } = selectProps;
  const {
    labelKey = 'label',
    OptionRightComp = () => <></>,
    containerRef = null,
  } = extraProps;
  const label = data?.[labelKey];

  return (
    <components.Option {...props}>
      <Flex flex="1" width="100%" justifyContent="space-between">
        <KText size="sm-medium">{label}</KText>
        <OptionRightComp value={data?.id} containerRef={containerRef} />
      </Flex>
    </components.Option>
  );
};
